<div class="idp-banner idp-banner-image banner-row" [ngStyle]="containerStyles">
  <idp-image
    *ngIf="desktopEnabled"
    [content]="content.imageContent?.desktop!"
    class="_banner_view _banner_view-desktop banner-col"
  ></idp-image>
  <idp-image
    *ngIf="mobileEnabled"
    [content]="content.imageContent?.mobile!"
    class="_banner_view _banner_view-mobile banner-col"
  ></idp-image>
  <idp-image
    *ngIf="desktopEnabled"
    [content]="content.imageContent?.tablet!"
    class="_banner_view _banner_view-tablet banner-col"
  ></idp-image>
</div>
